import * as React from 'react';
import CardContainer from '../../common/CardContainer';
import { Card } from '@blueprintjs/core';

interface ITitleCardProps {
    id?: string;
    name?: string;
}
const TitleCard: React.FC<ITitleCardProps> = (props) => {
    return (
        <div>
            <CardContainer id={props.id}>
                <Card elevation={1}>
                    <div className="card-header">
                        <div>{props.name}</div>
                    </div>
                </Card>
            </CardContainer>
        </div>
    );
};

export default TitleCard;



// WEBPACK FOOTER //
// ./src/components/personnel/components/TitleCard.tsx